import * as React from 'react';

import { useSelector } from 'react-redux';

import { selectEstimationTarget } from '../../selectors/estimationTarget';
import { trackMyHomeEstimationTargetSelect } from '../tracking';

import { EMyHomeEstimationTargets, TEstimationTargetProps } from '../../types/estimationTarget';
import { IDropdownFilterUI } from 'shared/common/utils/types';
import { useActions } from '../useActions';

export const ESTIMATION_TARGET_OPTIONS: IDropdownFilterUI<EMyHomeEstimationTargets>['values'] = [
  {
    value: EMyHomeEstimationTargets.flat,
    selectedLabel: 'Квартира',
    label: 'Квартира',
  },
  {
    value: EMyHomeEstimationTargets.house,
    selectedLabel: 'Дом',
    label: 'Дом',
  },
  {
    value: EMyHomeEstimationTargets.land,
    selectedLabel: 'Участок',
    label: 'Участок',
  },
];

export const useEstimationTargetProps = () => {
  const estimationTarget = useSelector(selectEstimationTarget);
  const { setEstimationTarget, resetForm, resetNewbuildingState } = useActions();

  const onValueChange = React.useCallback<TEstimationTargetProps['onValueChange']>(
    estimationTarget => {
      /** При выборе нового типа оцениваемой недвижимости, сбрасываем все предыдущие фильтры */
      resetForm();
      resetNewbuildingState();

      setEstimationTarget(estimationTarget);

      trackMyHomeEstimationTargetSelect(estimationTarget);
    },
    [setEstimationTarget, resetForm, resetNewbuildingState],
  );

  return {
    value: estimationTarget,
    values: ESTIMATION_TARGET_OPTIONS,
    placeholder: 'Тип недвижимости',
    onValueChange,
  };
};
